import { render, staticRenderFns } from "./FacesSnapshotModal.vue?vue&type=template&id=025b1134&scoped=true&lang=pug&"
import script from "./FacesSnapshotModal.vue?vue&type=script&lang=ts&"
export * from "./FacesSnapshotModal.vue?vue&type=script&lang=ts&"
import style0 from "./FacesSnapshotModal.vue?vue&type=style&index=0&id=025b1134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025b1134",
  null
  
)

export default component.exports